import { createTheme } from "@material-ui/core"
import { grey, orange } from "@material-ui/core/colors"

export default createTheme({
    props: {
        MuiButtonBase: {
            disableRipple: true
        }
    },
    palette: {
        primary: {
            main: orange[800]
        },
        secondary: {
            main: grey[500]
        },
        contrastThreshold: 3
    },
    typography: {
        body2: {
            fontSize: "1rem"
        }
    }
})
